import { EventViewData } from 'components/eventView/pages/eventData';

// Exhibitors   b652baa9-4cac-4f50-83f3-06bbc5d00586
// Speakers     a55033b6-99fe-49ad-a8f1-2b26a6ba257c
// Awards       9f3f5170-7d96-4189-afe3-10a5f81a4e28

export const ByglandEvent: EventViewData = {
    eventId: 'bygland',
    mapId: '184a8975-2e83-45a4-9257-319153d7a511',
    guideId: '5446047f-0b6c-4698-9bf1-573f97cdb00d'
};
